import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import alerts from './modules/alerts-module';
import notifications from './modules/notifications/notification-module';
import profile from './modules/profile-module';
import users from './modules/users-module';
import signature from './modules/settings/signature-module';
import roles from './modules/roles-module';
import categories from './modules/categories-module';
import tags from './modules/tags-module';
import items from './modules/items-module';
import labourers from './modules/vendors/labourers-module';
import vessels from './modules/settings/vessels-module';
import stations from './modules/settings/stations-module';
import shifts from './modules/settings/shifts-module';
import schedules from './modules/settings/schedules-module';
import ports from './modules/settings/ports-module';
import departments from './modules/settings/departments-module';
import activities from './modules/settings/activities-module';
import activityGuidances from './modules/settings/activity-guidances-module';
import permits from './modules/employers/permits-module';
import tariffActivities from './modules/employers/tariff-activity-module';
import activityTariffs from './modules/settings/activity-tariffs-module';
import tariffs from './modules/employers/tariff-module';
import workItems from './modules/employers/work-items-module';
import workDetails from './modules/employers/work-details-module';
import workplaces from './modules/employers/workplaces-module';
import works from './modules/employers/works-module';
import guidanceLabourers from './modules/vendors/gudance-labour-module';
import labourerSchedules from './modules/vendors/labourer-schedules-module';
import resets from './modules/general/reset-module';
import permissions from './modules/permissions-module';
import dashboard from './modules/dashboard-module';
import guidances from './modules/settings/guidances-module';
import guidanceWorkplaces from './modules/settings/guidance-workplaces-module';
import  vendors from './modules/vendors/vendors-module';
import zones from './modules/settings/zones-modules';
import regions from './modules/settings/regions-module';
import religions from './modules/settings/religions-module';
import attachmentTypes from './modules/settings/attachment-type-module';
import districtTypes from './modules/settings/district-type-module';
import districts from './modules/settings/districts-module';
import wards from './modules/settings/wards-module';
import villages from './modules/settings/villeges-module';
import neighborhoods from './modules/settings/neigborhoods-module';
import examCycles from './modules/settings/exam-cycles-module';
import levels from './modules/settings/levels-module';
import skillCategories from './modules/settings/skills-categories-modules';
import skills from './modules/settings/skills-modules';
import labourerParents from './modules/vendors/labourer-parents-module';
import institutions from './modules/employers/institutions-module';
import staffs from './modules/employers/staffs-module';
import employees from './modules/vendors/employees-module';
import labourerEducations from './modules/vendors/labourer-educations-module';
import attachments from './modules/vendors/attachments-module';
import holidays from './modules/settings/holidays-module';
import activityShifts from './modules/settings/activity-shifts-module';
import activityLabourerWorkplaces from './modules/settings/activity-labourer-workplaces-module';
import activityWorkplaces from './modules/settings/activity-workplaces-module';
import invoices from './modules/invoices/invoices-module';
import invoiceItems from './modules/invoices/invoice-items-module';
import statusOptions from './modules/settings/status-options-module';
import activitySkills from './modules/vendors/activity-skills-module';
import vouchers from './modules/invoices/vouchers-module';
import labourerAttendances from './modules/vendors/labourer-attendances-module';
import contributions from './modules/settings/contribution-module';
import labourerSkills from './modules/vendors/labourer-skills-module';

import guidanceCategories from './modules/settings/guidance-categories-modules';
import clients from '@/store/modules/settings/client-modules';
import biotimeAreas from "@/store/modules/biotimes/biotime-areas-module";
import biotimeAttendances from "@/store/modules/biotimes/biotime-attendances-module";
import biotimeDevices from "@/store/modules/biotimes/biotime-devices-module";
import biotimeSyncs from "@/store/modules/biotimes/biotime-syncs-module";
import stationTariffs from "@/store/modules/employers/station-tariff-module";
import biometricWhitelists from "@/store/modules/biotimes/biometric-whitelists-module";
import smsLogs from "@/store/modules/settings/sms-logs-module";
import labourerPayments  from "@/store/modules/vendors/labourer-payments-module";
import labourerPaymentItems  from "@/store/modules/vendors/labourer-payment-items-module";
import settings from "@/store/modules/utils/settings-module";
import labourerIssues from "@/store/modules/vendors/labourer-issues-module";
import passwordModule from "@/store/modules/password-module";
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        auth,
        alerts,
        notifications,
        stations,
        profile,
        users,
        roles,
        categories,
        labourers,
        tags,
        items,
        guidances,
        vessels,
        shifts,
        schedules,
        ports,
        departments,
        activities,
        activityGuidances,
        guidanceLabourers,
        labourerSchedules,
        attachments,
        permits,
        tariffActivities,
        activityTariffs,
        tariffs,
        workItems,
        workDetails,
        works,
        resets,
        workplaces,
        dashboard,
        permissions,
        guidanceWorkplaces,
        vendors,
        levels,
        examCycles,
        neighborhoods,
        villages,
        wards,
        districts,
        districtTypes,
        religions,
        regions,
        zones,
        attachmentTypes,
        skillCategories,
        skills,
        labourerParents,
        institutions,
        staffs,
        employees,
        labourerEducations,
        signature,
        holidays,
        activityShifts,
        invoices,
        invoiceItems,
        statusOptions,
        activitySkills,
        vouchers,
        labourerAttendances,
        contributions,
        guidanceCategories,
        clients,
        activityLabourerWorkplaces,
        activityWorkplaces,
        labourerSkills,
        biotimeAreas,
        biotimeAttendances,
        biotimeDevices,
        biotimeSyncs,
        stationTariffs,
        biometricWhitelists,
        smsLogs,
        labourerPayments,
        labourerPaymentItems,
        settings,
        labourerIssues,
        passwordModule
    }
});
